import { t } from 'i18next';
import room = egr.wcf.room;

export class RoomResources implements room.Resources {
    public get materialColor(): string { return t('Color'); }
    public get propertyArea(): string { return t('Area'); }
    public get propertyBackgroundImage(): string { return t('Background Image'); }
    public get propertyBlind(): string { return t('Blind'); }
    public get propertyColor(): string { return t('Color'); }
    public get propertyDepth(): string { return t('Depth'); }
    public get propertyDiameter(): string { return t('Diameter'); }
    public get propertyHeight(): string { return t('Height'); }
    public get propertyLength(): string { return t('Length'); }
    public get propertyMaterial(): string { return t('Material'); }
    public get propertyOnSite(): string { return t('On Site'); }
    public get propertyOpeningAngle(): string { return t('Opening Angle'); }
    public get propertyOpeningWidth(): string { return t('Opening Width'); }
    public get propertyParapet(): string { return t('Parapet'); }
    public get propertyPerimeter(): string { return t('Perimeter'); }
    public get propertyPrivacyFilter(): string { return t('Privacy Filter'); }
    public get propertyProportional(): string { return t('Proportional'); }
    public get propertyRouteWidth(): string { return t('Route Width'); }
    public get propertySegments(): string { return t('Segments'); }
    public get propertyScalePercantage(): string { return t('Scale (%)'); }
    public get propertyText(): string { return t('Text'); }
    public get propertyThickness(): string { return t('Thickness'); }
    public get propertyWidth(): string { return t('Width'); }
    public get propertyWallSideA(): string { return t('Wall Side a'); }
    public get propertyWallSideB(): string { return t('Wall Side b'); }
    public get propertyValueNo(): string { return t('No'); }
    public get propertyValueYes(): string { return t('Yes'); }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/RoomResources.ts